import {
    FB_CreatorMonthlyPaymentStatus,
    FB_AdminEmail,
    FB_QuestExplore, FB_QuestBody
} from "../../../functions/src/shareCode/Share_S_Classes";
import {date_newDate_fd} from "../S_Date";
import {obj_deepCopy_f} from "../../../functions/src/shareCode/Share_S_Obj";
import {
    fbRef_subRef,
    http_database_setData_f,
    http_endPointPath_oa,
    http_endPointPath_of,
    http_firestore_doc_get,
    http_firestore_doc_getAll,
    http_firestore_doc_filter_getAll_f,
    http_firestore_doc_getNewId_f,
    http_firestore_doc_update_f,
} from "./S_HttpRequests";
import {
    enum_emailsIds_uid,
    enum_questLocationsTypes_s,
    enum_questPermission_n
} from "../../../functions/src/shareCode/Share_S_Enum";
import {validator_objEmpty_fb} from "../../../functions/src/shareCode/Share_S_Validator";
import {serverPre_userDataSub_questPermission_set_f} from "./S_ServerPre";

// serverBig_createNewQuest
export const serverBig_createNewQuest = (questExplore_c, questBody_c) => {

    // let newQuestId_uid = firestore_getNewKey_fuid(REF_FIRESTORE_QUESTS_EXPLORE)
    // questExplore_c.qex_questId_uid = newQuestId_uid
    // questBody_c.qb_questId_uid = newQuestId_uid
    //
    //
    // // 1) add quest explore
    // firestore_setDoc(
    //     REF_FIRESTORE_QUESTS_EXPLORE.doc(newQuestId_uid),
    //     questExplore_c,
    //     () => {})
    //
    // // 2) add quest body
    // firestore_setDoc(
    //     getRef_firestore_questBody(questBody_c.qb_questType_e).doc(newQuestId_uid),
    //     questBody_c,
    //     () => {})
}

// -------------- quest explore --------------

// serverBig_getActiveQuestsExplore_f
export const serverBig_questsExplore_getAll_f = ({filterByActive_b, locationType_e, guidedQuest_b, cb_f}) => {

    if (filterByActive_b) {
        http_firestore_doc_filter_getAll_f({
            path_as: http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE,
            locationType_e: locationType_e,
            guidedQuest_b: guidedQuest_b,
            cb_f: (questExplore_ao) => {
                let questsExplores_ac = questExplore_ao.map((questExplore_o) => {
                    return new FB_QuestExplore(questExplore_o)
                })
                cb_f(questsExplores_ac)
            }
        })
    } else {
        http_firestore_doc_getAll({
            path_as: http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE,
            cb_f: (questExplore_ao) => {
                let questsExplores_ac = questExplore_ao.map((questExplore_o) => {
                    return new FB_QuestExplore(questExplore_o)
                })
                cb_f(questsExplores_ac)
            }
        })
    }
}

// serverBig_getQuestsExplore_filterByCreatorId_f
export const serverBig_getQuestsExplore_filterByCreatorId_f = (creatorId_uid, activeQuests_b, cb_f) => {

    http_firestore_doc_filter_getAll_f({
        path_as     : http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE,
        creatorId_uid: creatorId_uid,
        activeQuests_b,
        cb_f : (questExplore_ao) => {
            let questsExplores_ac = questExplore_ao.map((questExplore_o) => {
                return new FB_QuestExplore(questExplore_o)
            })
            cb_f(questsExplores_ac)
        }
    })
}

// serverBig_getQuestExplore_f
export const serverBig_questExplore_once_f = (questId_uid, cacheFallback_b,  cb_f) => {

    http_firestore_doc_get({
        path_as : http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE.concat(questId_uid),
        cacheFallback_b,
        cb_f : (questExplore_o) => {
            cb_f(new FB_QuestExplore(questExplore_o))
        }
    })

}

// serverBig_updateQuestExplore_fs
export const serverBig_questExplore_update_f = (questExplore_c, cb_f) => {

    http_firestore_doc_update_f({
        path_as: http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE.concat(questExplore_c.qex_questId_uid),
        newData_c: questExplore_c,
        cb_f: cb_f
    })
}

// serverBig_updateByAdmin_questExplore_f
export const serverBig_questExplore_updateByAdmin_f = (questExplore, cb_f) => {

    http_firestore_doc_update_f({
        path_as : http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE.concat(questExplore.qex_questId_uid),
        newData_c : {
            [fbRef_subRef.qex_metadata_c] : questExplore.qex_metadata_c,
            [fbRef_subRef.qex_langArr_ae] : questExplore.qex_langArr_ae,
            [fbRef_subRef.qex_mainLang_e] : questExplore.qex_mainLang_e,
            [fbRef_subRef.qex_creatorId_uid] : questExplore.qex_creatorId_uid,
            [fbRef_subRef.qex_shortKeyPrefixId_s] : questExplore.qex_shortKeyPrefixId_s
        },
        cb_f : (questExplore_o) => {
            cb_f(new FB_QuestExplore(questExplore_o))
        }
    })
}



// -------------- quest body --------------

// serverBig_once_questBody_f
export const serverBig_questBody_once_fp = (questType_e, questId_uid, getOnlyFromServer_b, cacheFallback_b, cb_f=()=>{}) => {

    return new Promise((resolve) => {

        http_firestore_doc_get({
            path_as     : http_endPointPath_of.FIRESTORE_QUEST_BODY_F(questType_e).concat(questId_uid),
            getOnlyFromServer_b,
            cacheFallback_b, 
            cb_f : (questBody_o) => {

                const questBody_c = validator_objEmpty_fb(questBody_o) ? null :new FB_QuestBody(questBody_o)
                cb_f(questBody_c)
                resolve(questBody_c)
            }
        })
    })

}

// serverBig_updateQuestBody_f
export const serverBig_questBody_update_f = (questBody_c, cb_f) => {

    http_firestore_doc_update_f({
        path_as :http_endPointPath_of.FIRESTORE_QUEST_BODY_F(questBody_c.qb_questType_e).concat(questBody_c.qb_questId_uid),
        newData_c : questBody_c,
        cb_f : cb_f
    })


}

// serverBig_updateByAdmin_questBody_f
export const serverBig_questBody_updateByAdmin_f = (questType_e, questId_uid, metadata_c, langArr_ar, mainLang_e, cb_f) => {

    http_firestore_doc_update_f({
        path_as : http_endPointPath_of.FIRESTORE_QUEST_BODY_F(questType_e).concat(questId_uid),
        newData_c : {
            [fbRef_subRef.qb_metadata_c] : metadata_c,
            [fbRef_subRef.qb_langArr_ae] : langArr_ar,
            [fbRef_subRef.qb_mainLang_e] : mainLang_e
        },
        cb_f : (questBody_c) => {
            cb_f(new FB_QuestBody(questBody_c))
        }
    })

}


// -------------- backup  --------------

// serverBig_questBody_backup_set_f
export const serverBig_questBody_backup_set_f = (questBody_c, questVersionInfo_c, playerId_uid, cb_f) => {


    // setBackUpId
    let setBackup_f  = (questBackupId_uid) => {

        questVersionInfo_c.qbi_savedByPlayerId_uid  = playerId_uid
        questVersionInfo_c.qbi_questBackupId_uid    = questBackupId_uid
        questVersionInfo_c.qbi_savedDate_t          = date_newDate_fd().getTime()

        // update storage files
        http_firestore_doc_update_f({
            path_as     : http_endPointPath_of.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_F(questBody_c.qb_questType_e, questBody_c.qb_questId_uid).concat(questBackupId_uid),
            newData_c   : new FB_QuestBody(obj_deepCopy_f(questBody_c)),
            cb_f : () => {

                // 3) update realtime db
                http_database_setData_f({
                    path_as : http_endPointPath_oa.DATABASE_MAIN_QUESTS_BACKUP_INFO.concat(questBody_c.qb_questType_e, questBody_c.qb_questId_uid, questBackupId_uid),
                    data_c  : questVersionInfo_c,
                    cb_f    : cb_f
                })

            },
        })

    }

    if(questVersionInfo_c.qbi_questBackupId_uid != null){
        setBackup_f(questVersionInfo_c.qbi_questBackupId_uid)
    }else{
        http_firestore_doc_getNewId_f({
            path_as     : http_endPointPath_of.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_F(questBody_c.qb_questType_e, questBody_c.qb_questId_uid),
            cb_f : (newId_uid) => {

                setBackup_f(newId_uid)
            }
        })
    }



}

// serverBig_questBody_backup_get_f
export const serverBig_questBody_backup_get_f = (questVersionInfo_c, cb_f) => {

    http_firestore_doc_get({
        path_as :  http_endPointPath_of.FIRESTORE_SUB_COLLECTION_QUEST_BACKUP_F(questVersionInfo_c.qbi_questType_e, questVersionInfo_c.qbi_questId_uid).concat(questVersionInfo_c.qbi_questBackupId_uid),
        cb_f    : (questBody_c) => {
            cb_f(new FB_QuestBody(questBody_c))
        }
    })
}


// -------------- admin emails  --------------

// serverBig_adminEmail_all_f
export const serverBig_adminEmail_getOnce_f = ({emailId_s, cb_f, cb_error_f}) => {

    http_firestore_doc_get({
        path_as : http_endPointPath_oa.FIRESTORE_ADMIN_EMAILS.concat(emailId_s),
        cb_f : (adminEmail_o) => {
            console.log(adminEmail_o)
            cb_f(adminEmail_o ? new FB_AdminEmail(adminEmail_o): null)
        },
        cb_error_f: cb_error_f
    })

}

// serverBig_adminEmail_update_f
export const serverBig_adminEmail_update_f = (adminEmail_c, cb_f) => {

    http_firestore_doc_update_f({
        path_as     : http_endPointPath_oa.FIRESTORE_ADMIN_EMAILS.concat(adminEmail_c.ae_id_uid),
        newData_c   : adminEmail_c,
        cb_f        : () => cb_f(adminEmail_c)
    })

}

// serverBig_admin_creatorsMonthlyPaymentSummary_getAll_f
export const serverBig_admin_creatorsMonthlyPaymentSummary_getAll_f = (date_mm_YYYY_s, cb_f) => {

    http_firestore_doc_getAll({
        path_as     : http_endPointPath_oa.FIRESTORE_ADMIN_CREATOR_MONTHLY_PAYMENT_SUMMARY.concat(date_mm_YYYY_s, "USERS_IDS"),
        cb_f        : (adminCreatorMonthlyPaymentSummary_ao) => {
            cb_f(adminCreatorMonthlyPaymentSummary_ao.map(item => new FB_CreatorMonthlyPaymentStatus(item)))
        }
    })

}


// serverBig_admin_creatorsMonthlyPaymentSummary_get_f
export const serverBig_admin_creatorsMonthlyPaymentSummary_update_f = (creatorMonthlyPaymentSummary_c, cb_f) => {

    http_firestore_doc_update_f({
        path_as     : http_endPointPath_oa.FIRESTORE_ADMIN_CREATOR_MONTHLY_PAYMENT_SUMMARY.concat(creatorMonthlyPaymentSummary_c.cmps_month_yyyy_mm_s, "USERS_IDS", creatorMonthlyPaymentSummary_c.cmps_creatorId_uid),
        newData_c   : creatorMonthlyPaymentSummary_c,
        cb_f        : () => cb_f()
    })
}


// -------------- admin --------------

// server_copyQuest_f
export const server_duplicateQuest_f = (questExplore_c, questBody_c, creatorId_uid, cb_f) => {


    // 0) set callback
    let callsNum = 3
    let cb_l = (newQuestExplore_c) => {
        callsNum--

        if (callsNum === 0) {
            cb_f(newQuestExplore_c)
        }
    }

    // 1) get new quest id
    http_firestore_doc_getNewId_f({
        path_as :  http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE,
        cb_f    : (newQuestId_uid) => {

            // 2) copy quest explore
            let newQuestExplore_c = new FB_QuestExplore(obj_deepCopy_f(questExplore_c))
            newQuestExplore_c.qex_questId_uid       = newQuestId_uid
            newQuestExplore_c.qex_creatorId_uid     = questExplore_c.qex_creatorId_uid
            newQuestExplore_c.qex_createdDateTime_n = (date_newDate_fd()).getTime()
            newQuestExplore_c.qex_creatorId_uid     = creatorId_uid

            newQuestExplore_c.qex_metadata_c.qexm_active_b = false

            http_firestore_doc_update_f({
                path_as     : http_endPointPath_oa.FIRESTORE_QUESTS_EXPLORE.concat(newQuestId_uid),
                newData_c   : newQuestExplore_c,
                cb_f        : () => cb_l(newQuestExplore_c, newQuestId_uid)
            })

            // 3) copy quest body
            let newQuestBody_c = new FB_QuestBody(obj_deepCopy_f(questBody_c))
            newQuestBody_c.qb_questId_uid = newQuestId_uid
            http_firestore_doc_update_f({
                path_as     : http_endPointPath_of.FIRESTORE_QUEST_BODY_F(questExplore_c.qex_questType_e).concat(newQuestId_uid),
                newData_c   : newQuestBody_c,
                cb_f        : () => cb_l(newQuestExplore_c)
            })

            // 4) add  permission to creator
            serverPre_userDataSub_questPermission_set_f({
                questType_e: questExplore_c.qex_questType_e,
                questId_uid: newQuestId_uid,
                userId_uid : questExplore_c.qex_creatorId_uid,
                permissionLevel_n: enum_questPermission_n.owner,
                cb_f: () => cb_l(newQuestExplore_c)
            })
        }
    })



}

// server_deleteQuest_f
export const server_deleteQuest_f = (questType, questId, creatorId_uid, cb) => {

    // 1) set reference
    // let refQuestExplore = REF_FIRESTORE_QUESTS_EXPLORE.doc(questId);
    // let refUserCreatedQuests = getRef_userData_subCollection(enum_subCollection_users.CREATED_QUESTS).child(questId);
    // let refQuestBody = getRef_firestore_questBody(questType).doc(questId)
    //
    // // 2) set callback
    // let callsNum = 3
    // let cb_l = () => {
    //     callsNum--
    //
    //     if (callsNum === 0) {
    //         cb()
    //     }
    // }
    //
    // // 3) delete quest explore
    // firestore_deleteDoc(refQuestExplore, cb_l)
    //
    // // 4) delete quest body
    // firestore_deleteDoc(refQuestBody, cb_l)
    //
    // // 5) delete from creator
    // realTimeDB_remove(refUserCreatedQuests, cb_l)


}

